(() => {
  const dialog = document.getElementById('GlobiOffers');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('[data-offer-form]');
  const data = JSON.parse(dialog.querySelector('[data-offer-data]').textContent);
  const submit = dialog.querySelector('[data-offer-submit]');
  const status = dialog.querySelector('[data-offer-status]');
  
  let busy = false, opener, previousOverflow;
  const selected = () => form.querySelector('[name="offer"]:checked')?.value;
  function variant() { return data[selected()] || null; }
  function update() {
    const item = variant();
    dialog.querySelectorAll('[data-offer-art]').forEach(image => { image.hidden = image.dataset.offerArt !== selected(); });
    submit.disabled = busy || !item?.id || !item.available;
    submit.textContent = busy ? 'Adding to your bag...' : !item ? 'Choose your pack' : !item.available ? 'This selection is unavailable' : `Add ${item.name} to bag`;
    form.querySelectorAll('[name="offer"]').forEach(input => { input.disabled = busy || !data[input.value]?.available; });
  }
  function open(trigger) {
    if (dialog.open || document.querySelector('dialog[open]')) return;
    opener = trigger || document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    try { sessionStorage.setItem('gf-offers-seen-v6', '1'); } catch (_) {}
    update();
  }
  document.querySelectorAll('[data-open-offers]').forEach(button => { button.hidden = false; });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-offers]');
    if (!trigger) return;
    event.preventDefault();
    const pack = trigger.dataset.offer;
    const radio = [...form.querySelectorAll('[name="offer"]')].find(input => (input.value === pack || input.dataset.group === pack) && !input.disabled);
    if (radio) radio.checked = true;
    open(trigger);
  });
  dialog.querySelector('[data-close-offers]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow || ''; opener?.focus?.({ preventScroll: true }); });
  form.addEventListener('change', () => { status.textContent = ''; update(); });
  if (!selected()) { const first = form.querySelector('[name="offer"]:not(:disabled)'); if (first) first.checked = true; }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const item = variant();
    if (busy || !item?.id || !item.available) return;
    busy = true; status.textContent = ''; update();
    try {
      const response = await fetch(`${dialog.dataset.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: item.id, quantity: 1 }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This pack could not be added. Please try again.');
      status.textContent = 'Your pack was added to the bag.';
      dialog.close();
      document.dispatchEvent(new CustomEvent('gf:cart-added'));
    } catch (error) { status.textContent = error.message || 'Please try again.'; }
    finally { busy = false; update(); }
  });
  update();
  if (dialog.dataset.autoOpen === 'true') setTimeout(() => {
    let seen = false; try { seen = sessionStorage.getItem('gf-offers-seen-v6') === '1'; } catch (_) {}
    if (!seen && !document.hidden && !document.activeElement?.matches('input,textarea,select') && !document.querySelector('dialog[open], [aria-modal="true"]')) open();
  }, 3000);
})();
